import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import "./styles/eventDashboard.css";
import Navbar from "./components/Navbar";
import AllRegData from "./pages/AllRegData";
import EventRegData from "./pages/EventRegData";
import ParticipantDetails from "./pages/ParticipantDetails";
import AllSAReg from "./pages/AllSAReg";
import SA from "./pages/SA";
import Login from "./pages/Login";
import SADetails from "./pages/SADetails";
import AllPayments from "./pages/AllPayments";
import AllOrders from "./pages/AllOrders";
import Attendance from "./pages/Attendance";
import Halls from "./pages/Halls";
import Winners from "./pages/Winner";
import EventDashboard from "./pages/EventDashboard";
import QueriesManagement from "./pages/QueriesManagement";
import QA from "./qa/QAApp";

// Protected Route Component for Queries
const ProtectedRoute = ({ children }) => {
	const token = localStorage.getItem('nssc-admin-token');
	
	if (!token) {
		return <Navigate to="/login" replace />;
	}
	
	return children;
};

// Layout component to conditionally show Navbar
const Layout = ({ children }) => {
	const location = useLocation();
	const hideNavbar = location.pathname === '/login';
	
	return (
		<>
			{!hideNavbar && <Navbar />}
			{children}
		</>
	);
};

function App() {
	return (
		<>
			<ToastContainer
				position="top-center"
				autoClose={5000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
				theme="dark"
			/>
			<Router>
				<Layout>
					<Routes>
						<Route exact path="/" element={<AllRegData />} />
						<Route path="login" element={<Login />} />
						<Route path="/event/:eid/" element={<EventRegData />} />
						<Route
							path="/participant/:pid/"
							element={<ParticipantDetails />}
						/>
						<Route path="/sa/" element={<SA />} />
						<Route exact path="/sa/reg/" element={<AllSAReg />} />
						<Route path="/sa/:saID/" element={<SADetails />} />
						<Route path="/payments" element={<AllPayments />} />
						<Route path="/orders" element={<AllOrders />} />
						<Route
							path="gl/attendance/:gl/"
							element={<Attendance glOrEvent={"gl"} />}
						/>
						<Route
							path="event/attendance/:gl/"
							element={<Attendance glOrEvent={"event"} />}
						/>
						<Route path="winners" element={<Winners />} />
						<Route path="halls" element={<Halls />} />
						<Route path="events/manage" element={<EventDashboard />} />
						<Route
							path="/queries" 
							element={
								<ProtectedRoute>
									<QueriesManagement />
								</ProtectedRoute>
							} 
						/>
						<Route
							path="/qa"
							element={
								<ProtectedRoute>
									<QA />
								</ProtectedRoute>
							}
						/>
						<Route path="*" element={<h1>404</h1>} />
					</Routes>
				</Layout>
			</Router>
		</>
	);
}

export default App;
